<template>
  <v-layout>
    <v-flex class="margin">
      <div
        v-if="mobileView"
        id="e3"
        style="max-width: 400px; margin: auto"
        class="grey lighten-3"
      >
        <v-card class="v-text-field-title" style="height: 600px">
          <v-toolbar color="#216AA9" dark v-if="mobileView">
            <!-- <v-toolbar-title>URL Payment Generator</v-toolbar-title> -->
            <v-icon style="font-size: 20px" @click="onClickBack"
              >mdi-arrow-left</v-icon
            >
            <v-flex class="texefild-mobile">สร้างรายการ</v-flex>
          </v-toolbar>

          <v-container fluid grid-list-lg>
            <v-layout class="text_url" style="margin-top: 30px">
              <v-flex md3>
                <span class="text-url">URL:</span>
              </v-flex>
              <v-flex md6>
                <v-text-field solo v-model="link"> </v-text-field>
              </v-flex>
              <v-btn
                color="#216AA9"
                style="font-size: 14px; height: 48px; border-radius: 3px"
                dark
                @click.stop.prevent="copyLink"
                >คัดลอกลิงค์</v-btn
              >
              <input type="hidden" id="testing-code" :value="link" />
            </v-layout>
            <v-flex
              style="text-align: center; margin-bottom: 20px; margin-top: 20px"
            >
              <span>หรือ</span>
            </v-flex>
            <v-layout class="layout-btn" style="margin-top: 30px">
              <center>
                <img :src="'data:image/jpeg;base64,' + qrcode" width="120px" />
              </center>
            </v-layout>
            <v-layout class="layout-btn" style="margin-top: 20px">
              <v-btn
                color="#216AA9"
                style="font-size: 14px; height: 40px; border-radius: 3px"
                dark
                @click="downloadQR()"
                >ดาวน์โหลดคิวอาร์</v-btn
              >
            </v-layout>
            <!-- <v-flex style="margin-top: 30px; text-align: right">
              <v-btn color="#216AA9" dark @click="onClickBack">ย้อนกลับ</v-btn>
            </v-flex> -->
          </v-container>
        </v-card>
      </div>

      <div
        v-if="!mobileView"
        id="e3"
        style="max-width: 1500px; margin: auto"
        class="grey lighten-3"
      >
        <v-card class="v-text-field-title" style="height: 700px">
          <v-toolbar color="#216AA9" dark>
            <!-- <v-toolbar-title><v-icon size="30px" @click="onClickBack">mdi-arrow-left-bold-circle</v-icon>
          URL Payment Generator</v-toolbar-title> -->
            <v-icon style="font-size: 20px" @click="onClickBack"
              >mdi-arrow-left</v-icon
            >
            <v-toolbar-title>สร้างรายการ</v-toolbar-title>
          </v-toolbar>

          <v-container fluid grid-list-lg>
            <!-- <v-flex style="margin-bottom: 20px">
              <v-btn color="#216AA9" dark @click="onClickBack">ย้อนกลับ</v-btn>
            </v-flex> -->
            <v-layout class="text_url" style="margin-top: 20px">
              <v-flex md3>
                <span class="text-url">URL : </span>
              </v-flex>
              <v-flex md6>
                <v-text-field solo v-model="link"> </v-text-field>
              </v-flex>
              <v-btn
                color="#216AA9"
                dark
                @click.stop.prevent="copyLink"
                style="font-size: 17px; height: 45px; border-radius: 3px"
                >คัดลอกลิงค์</v-btn
              >
              <input type="hidden" id="testing-code" :value="link" />
            </v-layout>
            <v-flex
              style="
                text-align: center;
                margin-bottom: 22px;
                font-size: 17px;
                margin-top: 20px;
              "
            >
              <span>หรือ</span>
            </v-flex>
            <v-layout class="layout-btn" style="margin-top: 30px">
              <center>
                <img
                  :src="'data:image/jpeg;base64,' + qrcode"
                  width="230px"
                /></center
            ></v-layout>
            <v-layout class="layout-btn" style="margin-top: 20px">
              <center>
                <v-btn
                  color="#216AA9"
                  dark
                  @click="downloadQR()"
                  style="font-size: 17px; height: 45px; border-radius: 3px"
                  >ดาวน์โหลดคิวอาร์</v-btn
                >
              </center></v-layout
            >
          </v-container>
        </v-card>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      mobileView: false,
      link: this.$cookies.get("link"),
      qrcode: localStorage.getItem("imageQR"),
    };
  },
  methods: {
    onClickBack() {
      this.$router.push("/createPayment");
    },
    handleView() {
      this.mobileView = window.innerWidth <= 990;
      this.$cookies.set("screenView", this.mobileView);
    },
    copyLink() {
      let testingCodeToCopy = document.querySelector("#testing-code");
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        // alert('Copied to Clipboard!');
      } catch (err) {
        console.log(err);
        // alert('Oops, unable to copy');
      }
      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    async downloadQR() {
      var a = document.createElement("a");
      a.href = "data:image/jpeg;base64," + this.qrcode;
      a.download = "qr_eEntry.png";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
  created() {
    this.handleView();
  },
};
</script>

<style>
.text_n {
  text-align: right;
}
.text_url {
  text-align: right;
  margin-right: 20px;
}
.text-url {
  font-size: 18px;
  font-weight: bold;
}
.v-text-field-title {
  border: #ccc;
  border-radius: 5px;
}
.texefild-mobile {
  font-size: 18px;
  margin-left: 20px;
}
</style>
